<div id="unread-tidemark">
  <div>NEW ACTIVITY</div>
</div>
